var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h4', [_vm._v(_vm._s(this.title))])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ユーザーID（メールアドレス）",
      "required": "",
      "rules": _vm.requiredFieldRules,
      "disabled": _vm.currentUser !== null
    },
    model: {
      value: (_vm.userId),
      callback: function($$v) {
        _vm.userId = $$v
      },
      expression: "userId"
    }
  }), _vm._v(" "), (_vm.currentUser === null) ? _c('div', [_c('v-text-field', {
    attrs: {
      "label": "パスワード",
      "required": "",
      "type": "password",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "パスワード（確認）",
      "required": "",
      "type": "password",
      "rules": _vm.passwordRetypeRules
    },
    model: {
      value: (_vm.passwordRetype),
      callback: function($$v) {
        _vm.passwordRetype = $$v
      },
      expression: "passwordRetype"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "姓",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "姓（かな）",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.lastNameKana),
      callback: function($$v) {
        _vm.lastNameKana = $$v
      },
      expression: "lastNameKana"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "名",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "名（かな）",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.firstNameKana),
      callback: function($$v) {
        _vm.firstNameKana = $$v
      },
      expression: "firstNameKana"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h6', [_vm._v("お持ちの製品を選択してください。")]), _vm._v(" "), _c('product-select', {
    ref: "productSelect",
    on: {
      "load-master": _vm.onLoadProductMaster
    }
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "warning": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.errMessage)
    },
    model: {
      value: (_vm.visibleErrMessage),
      callback: function($$v) {
        _vm.visibleErrMessage = $$v
      },
      expression: "visibleErrMessage"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "indigo--text darken-2",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.saveBtnLabel) + "\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-2",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082ef383","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserReg.vue
// module id = LDsl
// module chunks = 1